/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relative centrifugal force is the force on a sample in a centrifuge, measured as a multiple of gravity (×g). It reflects the actual force, unlike RPM.`)
};

const es_gf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fuerza centrífuga relativa es la fuerza sobre una muestra en una centrífuga, medida como un múltiplo de la gravedad (×g). Refleja la fuerza real, a diferencia de las RPM.`)
};

const de_gf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die relative Zentrifugalkraft ist die Kraft, die auf eine Probe in einer Zentrifuge wirkt, gemessen als Vielfaches der Erdanziehungskraft (×g). Sie bildet die tatsächliche Kraft ab, im Gegensatz zur Drehzahl.`)
};

const nl_gf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatieve centrifugale kracht is de kracht op een monster in een centrifuge, gemeten als een veelvoud van de zwaartekracht (×g). Het weerspiegelt de werkelijke kracht, in tegenstelling tot RPM.`)
};

const fr_gf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La force centrifuge relative est la force exercée sur un échantillon dans une centrifugeuse, mesurée comme un multiple de la gravité (×g). Elle reflète la force réelle, contrairement aux RPM.`)
};

const it_gf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La forza centrifuga relativa è la forza esercitata su un campione in una centrifuga, misurata come multiplo della gravità (×g). Riflette la forza reale, a differenza degli RPM.`)
};

const pt_br2_gf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força centrífuga relativa é a força sobre uma amostra em uma centrífuga, medida como um múltiplo da gravidade (×g). Ela reflete a força real, ao contrário da RPM.`)
};

const pt_gf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A força centrífuga relativa é a força exercida sobre uma amostra numa centrífuga, medida como um múltiplo da gravidade (×g). Reflete a força real, ao contrário da RPM.`)
};

const ja_gf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相対遠心力とは、遠心分離機内の試料にかかる力を重力の倍数(×g)で表したものです。RPMとは異なり、実際にかかる力を反映します。`)
};

const zh_gf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相对离心力是离心机中作用于样品的力，以重力的倍数（×g）衡量。与 RPM 不同，它反映的是实际作用力。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_faq_a1", locale)
	if (locale === "en") return en_gf_faq_a1(inputs)
	if (locale === "es") return es_gf_faq_a1(inputs)
	if (locale === "de") return de_gf_faq_a1(inputs)
	if (locale === "nl") return nl_gf_faq_a1(inputs)
	if (locale === "fr") return fr_gf_faq_a1(inputs)
	if (locale === "it") return it_gf_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_gf_faq_a1(inputs)
	if (locale === "pt") return pt_gf_faq_a1(inputs)
	if (locale === "ja") return ja_gf_faq_a1(inputs)
	return zh_gf_faq_a1(inputs)
};